module.exports = __webpack_public_path__ + "static/scale-model-of-matthaei-botanical-gardens-in-ann-arbor-michigan-2829d5693996883d16d04855dfbf409a.png";